<template>
  <li class="page-header__menu-item"
      :class="isOpen ? '_open' : null"
  >
    <router-link
      v-if="item.title"
      :to="computedSrc"
      class="page-header__menu-link">{{item.title}}</router-link>

    <div v-else class="page-header__menu-link" @click.prevent="onToggle">{{item.name}}</div>

    <div v-if="item.restaurants && item.restaurants.length"
         class="page-header__menu-item-arrow"
         @click.prevent="onToggle"
    ></div>
    <v-slide-toggle v-if="item.restaurants && item.restaurants.length"
                    :active="isOpen"
                    class="page-header__submenu-wrap"
    >
      <ul class="page-header__submenu">
        <slot></slot>
      </ul>
    </v-slide-toggle>
  </li>
</template>

<script>

  import windowSizeMixin from '../mixins/windowSizeMixin'

  export default {
    name: 'HeaderToggleItem',
    mixins: [windowSizeMixin],
    props: {
      item: {
        type: Object,
        required: true
      },
      toChild: {
        type: String,
        default: null
      },
      categoryId: {
        type: [String, Number],
        default: null
      },
      categorySlug: {
        type: [String, Number],
        default: null
      }
    },
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      computedSrc() {
        let obj
        if (this.item.to) {
          obj = {
            name: this.item.to
          }
        } else if (this.categoryId && this.categorySlug) {
          obj = {
            name: `${this.toChild}-with-category`,
            params: {
              id: this.item.id,
              categoryId: this.categoryId,
              slug: this.item.slug,
              categorySlug: this.categorySlug,
            }
          }
        } else if (this.toChild) {
          obj = {
            name: this.toChild,
            params: {
              id: this.item.id,
              slug: this.item.slug
            }
          }
        } else {
          obj = {
            name: '#'
          }
        }
        return obj
      }
    },
    methods: {
      onToggle() {
        this.isOpen = !this.isOpen
      }
    }
  }
</script>

<style>

</style>
